import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getTicketProtocol } from '../../utils/ticketDisplayUtils';

const Chip = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 0.35rem;
  width: fit-content;
  max-width: 100%;
  
  border-radius: 6px;
  color: var(--color-text-secondary);
  font-size: ${({ $compact }) => ($compact ? '0.72rem' : '0.8rem')};
  font-weight: 600;
  line-height: 1.3;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
`;

const Label = styled.span`
  font-weight: 500;
  color: var(--color-text-muted);
  flex-shrink: 0;
`;

const Value = styled.span`
  color: var(--color-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TicketProtocolLabel = ({ ticket, compact = false }) => {
  const protocol = getTicketProtocol(ticket);
  if (!protocol) return null;

  return (
    <Chip $compact={compact} title={`Protocolo ${protocol}`}>

      <Value>{protocol}</Value>
    </Chip>
  );
};

TicketProtocolLabel.propTypes = {
  ticket: PropTypes.object,
  compact: PropTypes.bool,
};

export default TicketProtocolLabel;
